import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    allPolicyCounts: {},
    monthWisePolicyCounts: {},
    allPunchedPolicyList: {},
    currentMonthPolicyList: {},
  },
  reducers: {
    setAllPolicyCounts: (state, action) => {
      state.allPolicyCounts = action?.payload;
    },
    setMonthWiseCount: (state, action) => {
      state.monthWisePolicyCounts = action?.payload;
    },
    setAllPunchedPolicyList: (state, action) => {
      state.allPunchedPolicyList = action?.payload;
    },
    setCurrentMonthPolicyList: (state, action) => {
      state.currentMonthPolicyList = action?.payload;
    },
    clearAllPolicyCountDetails: (state) => {
      state.allPolicyCounts = {};
      state.monthWisePolicyCounts = {};
      state.allPunchedPolicyList = {};
      state.currentMonthPolicyList = {};
    },
  },
});

export const {
  setAllPolicyCounts,
  setMonthWiseCount,
  setAllPunchedPolicyList,
  setCurrentMonthPolicyList,
  clearAllPolicyCountDetails,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
